import type { ComponentType } from 'react';
import { lazyForPaint } from 'react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CreateSamplePlanContent = lazyForPaint<ComponentType<Record<any, any>>>(() =>
	import(/* webpackChunkName: "async-portfolio-3-create-sample-plan" */ './index').then(
		(module) => module.default,
	),
);

export default CreateSamplePlanContent;
